module.exports = __webpack_public_path__ + "static/img/2-0.81ee7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/2-0.jpg
// module id = VxzT
// module chunks = 1